<template>
  <div class="my-page-customer-service mt-4">
    <hl-ButtonTapWithIcon
      iconClass="budicon-life-buoy"
      link="https://husleie-no.zendesk.com/hc/no"
      target="_blank"
      layout="vertical"
    >
      <p class="font-weight-bold">FAQ</p>
    </hl-ButtonTapWithIcon>

    <hl-ButtonTapWithIcon v-if="hasSubscription" iconClass="budicon-phone" link="tel:+4722475800" layout="vertical">
      <p class="font-weight-bold">22 47 58 00</p>
    </hl-ButtonTapWithIcon>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonTapWithIcon from '@modules/husleie-framework/src/components/buttons/ButtonTapWithIcon.vue';

export default {
  name: 'MyPageCustomerService',
  props: {
    hasSubscription: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    'hl-ButtonTapWithIcon': ButtonTapWithIcon,
  },
  computed: {
    ...mapGetters(['getWhoAmI']),
  },
};
</script>

<style scoped lang="scss">
.my-page-customer-service {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-auto-rows: 1fr;
  gap: 1rem;
}
.my-page-customer-service > * {
  height: 100%;
}

.item {
  color: inherit;
  text-decoration: none;
}
</style>
